import React from 'react';
import { Link } from 'react-router-dom';
import './AddNewLi.css';

// const addRoute = RouteKey => {
//     let addRoute = `${RouteKey}/add`
// }
export default (props) => {
	let addRoute = `${props.RouteKey}/add`;
	return (
		< div >
			<Link to={addRoute}>
				<div className="addNewLi">
					<svg id="plusIcon" width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" >
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g id="Artboard" fill="#000000">
								<g id="plus-icon">
									<g id="Layer_1">
										<path d="M58.2593894,21.7919166 L38.5527964,21.7919166 L38.5527964,2.09021677 C38.5527964,1.27386601 37.8905818,0.612466949 37.0750466,0.611651414 L23.272113,0.611651414 C22.4557623,0.611651414 21.7943632,1.27386601 21.7943632,2.09021677 L21.7935477,21.7935477 L2.0910323,21.7927321 C1.30730296,21.7927321 0.613282485,22.4867526 0.612466949,23.2712975 L0.612466949,37.074231 C0.611651414,37.4665035 0.768234176,37.8432808 1.04551615,38.1197472 C1.32198259,38.3962136 1.69875986,38.5527964 2.0910323,38.5519809 L21.7943632,38.5519809 L21.7943632,58.2593894 C21.7943632,58.6508463 21.9501304,59.0276236 22.2274124,59.3049056 C22.5046944,59.5821876 22.8814716,59.7379548 23.2729285,59.7379548 L37.074231,59.7379548 C37.465688,59.7379548 37.8432808,59.581372 38.1213783,59.3032745 C38.3970292,59.0276236 38.5527964,58.6508463 38.5527964,58.2593894 L38.5527964,38.5527964 L58.2585739,38.5519809 C58.6663415,38.5519809 59.035779,38.3872428 59.30409,38.1197472 C59.5724011,37.8514361 59.7371392,37.4819987 59.7371392,37.0734155 L59.7379548,23.2704819 C59.7379548,22.4541312 59.0765557,21.7927321 58.2593894,21.7919166 L58.2593894,21.7919166 Z" id="plus-icon"></path>
									</g>
								</g>
							</g>
						</g>
					</svg>
					<p className="mainDesc">{props.mainDesc}</p>
				</div>
			</Link>
		</div >
	);
};



// WEBPACK FOOTER //
// ./src/Components/Li/AddNewLi/index.js